export default __webpack_public_path__ + "static/media/CANCIONES_DISCO_03.de974cd5.png";